import {PayloadAction, createSlice} from '@reduxjs/toolkit';

export interface UIState {
  readonly isLogoExpanded: boolean;
}
export const initialState: UIState = {
  isLogoExpanded: true,
};

const {actions: UIActions, reducer: UIStateReducer} = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    setIsLogoExpanded(state, action: PayloadAction<boolean>) {
      state.isLogoExpanded = action.payload;
    },
  },
});

export {UIActions};
export default UIStateReducer;
